var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrintReceiptIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.132,
    height: 24.18,
    viewBox: "0 0 18.132 24.18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "payment-terminal-_1_",
    transform: "translate(-63.85 511.627)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2521",
    "data-name": "Path 2521",
    d: "M70.119-511.611a3.816,3.816,0,0,0-2.788,2.013,3.541,3.541,0,0,0-.4,1.838v.652h-.411a2.468,2.468,0,0,0-1.976.681,2.07,2.07,0,0,0-.614,1.1c-.1.482-.1,15.615,0,16.1a2.263,2.263,0,0,0,1.716,1.73c.175.038,1.938.052,5.79.052,6.026,0,5.785.009,6.324-.265a2.379,2.379,0,0,0,1.068-1.2c.08-.2.085-.548.109-4.821l.024-4.608.4-.208.4-.2.69.336a2.919,2.919,0,0,0,.86.336.808.808,0,0,0,.581-.345c.1-.132.1-.137.1-5.1V-508.5l-.132-.425a3.839,3.839,0,0,0-2.595-2.585l-.345-.1-4.324-.009C72.208-511.63,70.2-511.621,70.119-511.611Zm5.109,1.489a4.228,4.228,0,0,0-.685,1.683c-.028.194-.052,1.03-.052,1.99v1.659H68.347v-1.739c0-1.881.009-1.971.269-2.491a2.736,2.736,0,0,1,.974-.94c.506-.25.572-.255,3.242-.26l2.472,0Zm3.564-.028a2.4,2.4,0,0,1,1.664,1.512l.109.279.014,4.192c.009,2.618,0,4.2-.033,4.2a2.038,2.038,0,0,1-.345-.142.784.784,0,0,0-.879,0,2.038,2.038,0,0,1-.345.142c-.024,0-.047-1.2-.052-2.732l-.014-2.727-.17-.354a2.234,2.234,0,0,0-2.226-1.309l-.6-.028v-.458a2.469,2.469,0,0,1,.633-1.876A2.277,2.277,0,0,1,78.792-510.151Zm-11.863,5.407c.028,1.016.038,1.059.331,1.243l.165.1h4c3.965,0,4,0,4.131-.1.312-.232.326-.274.35-1.262l.024-.907.354-.014c.529-.024.808.052,1.011.274a.981.981,0,0,1,.194.293c.014.061.019,3.63.014,7.935l-.014,7.826-.128.165c-.265.345.1.326-6.045.312l-5.511-.014-.175-.137a.99.99,0,0,1-.269-.34c-.09-.194-.09-.435-.08-7.968L65.3-505.1l.109-.17c.2-.331.43-.416,1.073-.406l.425.009Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2522",
    "data-name": "Path 2522",
    d: "M129.34-302.905a.869.869,0,0,0-.246.246c-.09.147-.095.241-.095,1.881s0,1.734.095,1.881a.869.869,0,0,0,.246.246c.151.09.246.095,4.126.095,3.686,0,3.979,0,4.131-.085a.827.827,0,0,0,.26-.213c.095-.132.1-.189.1-1.924s0-1.791-.1-1.924a.827.827,0,0,0-.26-.213c-.151-.08-.444-.085-4.131-.085C129.586-303,129.492-303,129.34-302.905Zm7.222,2.127v.8h-6.144v-1.607h6.144Z",
    transform: "translate(-62.071 -198.767)",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2526",
    "data-name": "Path 2526",
    d: "M145.465-109.9a.6.6,0,0,0-.345.548.623.623,0,0,0,.4.685.7.7,0,0,0,.879-1.007A.713.713,0,0,0,145.465-109.9Z",
    transform: "translate(-77.425 -383.656)",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2527",
    "data-name": "Path 2527",
    d: "M209.452-109.927a.682.682,0,0,0-.217.931.649.649,0,0,0,.6.35.7.7,0,0,0,.378-1.286A.724.724,0,0,0,209.452-109.927Z",
    transform: "translate(-138.416 -383.609)",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2528",
    "data-name": "Path 2528",
    d: "M273.61-109.932a.7.7,0,0,0,.378,1.286.7.7,0,0,0,.383-1.281A.724.724,0,0,0,273.61-109.932Z",
    transform: "translate(-199.545 -383.609)",
    fill: "#000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrintReceiptIcon);
export default __webpack_public_path__ + "static/media/printReceiptIcon.57789d5ca3446bb9b25ae416d59df889.svg";
export { ForwardRef as ReactComponent };